<template>
    <section class="feeScale">
        <!-- <header-com class='header'/> -->

        <van-tabs background="#f8f8f8" color="#7ADFDF" title-inactive-color="#999" title-active-color="#333" swipeable v-model="activeIndex" class='myTab'>
          <van-tab v-for="(item,index) in navData" :key="index" :title="item.name">
            
          </van-tab>
        </van-tabs>

        <section class="content">
            <img :src="'/images/home/'+navData[activeIndex].img" alt="">
        </section>
        <div class="tool-bar f28">
            <div style="width:100%">
                <!-- <div  id="alldo" style="float: left;position:absolute;width:160px;z-index:999;height: 50px;">
                </div> -->
                    
                <!-- <button class="kefu" ><img src="/images/base/wechart-icon.png" class="icon" alt="">问客服</button> -->
                <button class="kefu2" @click='toPublic'><img src="/images/base/wechart-icon.png" class="icon" alt="">问客服</button>
                
                
                <button class="primary pay" @click='submit()'>寄给我们评估</button>
            </div>
        </div>    
    </section>
</template>

<script>
    import wxShare from "@/assets/js/wx.share"
    import { setTimeout } from 'timers';
    import getWXConfig from "@/assets/js/wx.config";
    import zhugeObj from "@/assets/js/track";
    export default {
        name: "index",
        components:{},
        data() {
            return {
                activeIndex:0,
                navData:[
                    {name:"包包",img:'feeScale_01_v1.png'},
                    {name:"鞋靴",img:'feeScale_02_v1.png'},
                    {name:"衣裤",img:'feeScale_03_v1.png'},
                    {name:"配饰",img:'feeScale_04_v1.png'}
                ],
                tabData : ['包包','鞋靴','衣裤','配饰']
            }
        },
        watch: {},
        computed: {},
        created() {
        },
        mounted() {
            zhugeObj.track({
                title: "收费标准页-曝光"
            });
            setTimeout(()=>{
                let shareBody = {
                    desc : '良心掏给你看~',
                    title : '奢护行业价格重新定义，一点儿都不贵的包拯',
                }; 
                wxShare(shareBody);
            },1000)
            getWXConfig({path:'http://mi.baozheng.cc'})

            // 屏蔽客服按钮
            // var dom = document.getElementById('alldo') //
            // let urlend = encodeURIComponent(window.location.href)
            // dom.innerHTML = '<wx-open-launch-weapp path="pages/kefu/index.html?h5Url=我正在浏览收费标准：'+urlend+'" id="launch-btn"   username="gh_f36f18f6beed"><template><div style="width:160px;height:45px;"></div></template></wx-open-launch-weapp>'
        
            // var launchBtn = document.getElementById('launch-btn')
            // if (!launchBtn) {
            // return
            // }
            // launchBtn.addEventListener('launch', function (e) {
            //     zhugeObj.track({
            //         title: "收费标准页-问客服按钮-点击"
            //     });
            // })
            // launchBtn.addEventListener('error', function (e) {
            // console.log('fail', e.detail)
            // })
        },
        methods: {
            toPublic() {
                window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAwNjUzNzQyNA==&scene=124#wechat_redirect'
            },
            submit(){
                zhugeObj.track({
                    title: "收费标准页-寄给我们评估按钮-点击"
                });
                this.$router.push({
                    name: "quick"
                });
            },
            changeTab(item,index){
                this.activeIndex=index+1
            }
        }
    }
</script>

<style scoped lang="scss">
.header{
    background: #fff!important;
}
.feeScale{
    // padding: .55rem 0 0;
    .myTabNav{margin-left:.2rem}
    img{width: 100%}
}
.myTab{
    // width: 85%;
    width: 100%;
    position: fixed;
    top:0;
    z-index: 100;
    right: 0;
}
.content{
    margin-top: 100px;
}
.tool-bar{
    position: fixed;
    width: 100%;
    display: flex;
    z-index: 9;
    align-items: center;
    height: 108px;
    bottom: 0px;
    left: 0;
    background:rgba(255,255,255,1);
    box-shadow:0px -2px 20px 0px rgba(0,0,0,0.06);
    justify-content: flex-end;

    .pay{
        width: 44.2666%;
        height: 84px;
    }
}
.kefu,.kefu2{
    width: 44.2666%;
    height: 84px; 
    font-size: 30px;

    margin-left:3.8%;
    margin-right:3.8%;
    box-shadow: 0px 0px 8px 0px rgba(0, 217, 103, 0.1);
    border-radius: 46px;
    border: 4px solid #333333;
    position: relative;
    top: -3px;
    font-weight: 600;
    .icon{
        display: inline-block;vertical-align: middle;width: 40px;height: 40px;margin: 10px;
    }
}
</style>
